import { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'polished';
import { getCDNPath, assetTypes } from '../../utils/cdn';
var StyledGlobalStyle = createGlobalStyle(["", " ", " ", " ", " ", " *{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}"], normalizeStyle, borderBox, fontImpact, fontAccent, fontSourceSansPro);

function borderBox(props) {
  return props.borderBox && css(["*,*:before,*:after{box-sizing:border-box;}"]);
}

function normalizeStyle(props) {
  return props.normalize && normalize();
}

function fontImpact(props) {
  if (typeof window === 'undefined' || !props.fontImpact) {
    return;
  }

  return css(["@font-face{font-family:'NABImpact';src:url(", "/NABImpact.woff) format('woff');font-weight:normal;font-style:normal;font-display:auto;}"], getCDNPath(assetTypes.fonts, props.customCDN));
}

function fontAccent(props) {
  if (typeof window === 'undefined' || !props.fontAccent) {
    return;
  }

  return css(["@font-face{font-family:'NABScript';src:url(", "/NABScript.woff) format('woff');font-weight:normal;font-style:normal;font-display:auto;}"], getCDNPath(assetTypes.fonts, props.customCDN));
}

function fontSourceSansPro(props) {
  if (typeof window === 'undefined' || !props.fontSourceSansPro) {
    return;
  }

  var cdnPath = "".concat(getCDNPath(assetTypes.fonts, props.customCDN), "/");
  return css(["@font-face{font-family:'SourceSansPro';font-weight:300;font-style:normal;font-display:auto;src:url(", "/SourceSans-Light.woff) format('woff');}@font-face{font-family:'SourceSansPro';font-weight:400;font-style:normal;font-display:auto;src:url(", "/SourceSans-Regular.woff) format('woff');}@font-face{font-family:'SourceSansPro';font-weight:600;font-style:normal;font-display:auto;src:url(", "/SourceSans-Semibold.woff) format('woff');}@font-face{font-family:'SourceSansPro';font-weight:700;font-style:normal;font-display:auto;src:url(", "/SourceSans-Bold.woff) format('woff');}"], cdnPath, cdnPath, cdnPath, cdnPath);
}

export default StyledGlobalStyle;